<template>
  <div>
    <div v-if="loading" class="loader-container">
      <site-loader />
    </div>
    <div
      v-else
      class="contact-view"
      :style="{ 'padding-top': siteHeaderHeight }"
    >
      <site-header />
      <div class="contact-content-wrapper">
        <div class="contact-content">
          <div class="contact-icon">
            <img src="@/assets/contact-icon.svg" alt="Contact Icon" />
          </div>
          <h1 class="text-h2 font-weight-bold mb-4">Get in Touch</h1>
          <p
            class="text-subtitle-1 text-medium-emphasis mb-12"
            style="line-height: 1.8"
          >
            We're here to help you find your perfect vacation rental. Whether
            you have questions about a property, need assistance with a booking,
            or just want to learn more about our services, our team is ready to
            assist you.
          </p>
          <div class="contact-details">
            <h2 class="text-h6 font-weight-medium text-medium-emphasis mb-4">
              Call us directly
            </h2>
            <v-btn
              :href="`tel:${settings?.business?.phone}`"
              color="primary"
              size="x-large"
              class="text-none px-8 py-3"
              rounded="lg"
              elevation="2"
            >
              <v-icon start icon="mdi-phone" class="mr-3"></v-icon>
              <span class="text-h6">{{ settings?.business?.phone }}</span>
            </v-btn>
          </div>
        </div>
      </div>
      <site-footer />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SiteHeader from "@/components/header/site-header.vue";
import SiteFooter from "@/components/footer/site-footer.vue";
import SiteLoader from "@/components/common/site-loader.vue";
import StylesMixin from "@/mixins/styles-mixin";

export default {
  name: "ContactView",
  components: {
    SiteHeader,
    SiteFooter,
    SiteLoader,
  },
  mixins: [StylesMixin],
  data: () => ({
    loading: true,
  }),
  computed: {
    ...mapState({
      settings: (state) => state.settingsModule.settings,
    }),
  },
  mounted() {
    this.loading = false;
  },
};
</script>

<style scoped>
.contact-view {
  min-height: 100vh;
  background-color: #fafafa;
}

.contact-content-wrapper {
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(
    100vh - 64px - 300px
  ); /* Subtract header and footer heights */
}

.contact-content {
  max-width: 700px;
  text-align: center;
  background-color: white;
  padding: 4rem;
  border-radius: 24px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
}

.contact-icon {
  margin-bottom: 2.5rem;
  display: inline-block;
}

.contact-icon img {
  width: 96px;
  height: 96px;
  filter: drop-shadow(0 4px 12px rgba(255, 64, 129, 0.2));
}

.contact-details {
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 16px;
  margin-top: 2rem;
}

@media (max-width: 600px) {
  .contact-content-wrapper {
    padding: 1rem;
    min-height: calc(
      100vh - 56px - 250px
    ); /* Adjust for mobile header/footer */
  }

  .contact-content {
    padding: 2rem 1.5rem;
    margin: 0 1rem;
  }

  .contact-icon img {
    width: 80px;
    height: 80px;
  }

  .contact-details {
    padding: 1.5rem;
  }
}
</style>
